import getPlanIdWorkoutUtil from '../../../../modules/workout/model/utils/get-plan-id'
import getPlannedAtWorkoutUtil from '../../../../modules/workout/model/utils/get-planned-at'
import sortByArrayUtil from 'packages/src/modules/array/sort-by'

import cloneIfCantEditPlanAction from '../clone-if-cant-edit'
import updateDataPlanAction from '../update-data'
import PLANS_ACTION from '../../constants/action'
import PLANS_ANALYTICS_EVENT from '../../constants/analytics-event'
import getAllWorkoutsPlanSelector from '../../selectors/get-all-workouts'
import getByIdPlanSelector from '../../selectors/get-by-id'
import updateReduxAction from '../../../redux/actions/update'
import createPointerReduxUtil from '../../../redux/utils/create-pointer'
import { getIdReduxUtil } from '../../../redux/utils/get-id'
import getInstanceReduxUtil from '../../../redux/utils/get-instance'
import { getPathReduxUtil } from '../../../redux/utils/get-path'
import saveWorkoutAction from '../../../workout/redux/actions/save'
import updatePlanIdWorkoutAction from '../../../workout/redux/actions/update-plan-id'
import { logUtil } from 'packages/src'
import { logEventAnalyticsUtil } from '../../../../utils/analytics/log-event'
import { PLAN_KEY } from '../../../plan/model/constants'

function addWorkoutLogPlanAction (workout) {
  return async (dispatch, getState) => {
    let plan = getByIdPlanSelector(getPlanIdWorkoutUtil(workout))(getState())

    if (!plan) {
      logUtil('').warn(`plan not found for workout with id ${getIdReduxUtil(workout)}`)
      return
    }

    plan = await dispatch(cloneIfCantEditPlanAction(plan))

    dispatch(updatePlanIdWorkoutAction({
      workout,
      value: getIdReduxUtil(plan)
    }))

    let workouts = getAllWorkoutsPlanSelector(plan)(getState())
    workouts = sortByArrayUtil([
      ...workouts,
      workout
    ],
    (workoutPlanWorkout) => (
      new Date(getPlannedAtWorkoutUtil(workoutPlanWorkout)).getTime()
    )
    )
    dispatch(updateReduxAction({
      type: PLANS_ACTION.ADD_WORKOUT_LOG,
      payload: {
        path: getPathReduxUtil(plan),
        updates: {
          [PLAN_KEY.WORKOUTS]: workouts.map(createPointerReduxUtil)
        }
      }
    }))

    plan = getInstanceReduxUtil(getState(), plan)

    dispatch(updateDataPlanAction(plan))

    dispatch(saveWorkoutAction(getIdReduxUtil(workout)))

    plan = getInstanceReduxUtil(getState(), plan)
    logEventAnalyticsUtil(PLANS_ANALYTICS_EVENT.WORKOUT_LOGGED, {
      plan,
      workout
    })
  }
}

export default addWorkoutLogPlanAction
